import {ListTable} from "../../../layout/content/list/ListTable";
import {DetailActionButton} from "../../../components/Buttons";
import organshareIcon from "../../../assets/images/button_icons/person-add-icon.png";
import {ListCount, WhichList} from "../../../components/ListCount";
import React, {useEffect, useState} from "react";
import {useOrganShareGetter} from "./hooks/useOrganShareGetter";
import {useOrganShareFilters} from "./hooks/useOrganShareFilters";
import {useOrganShareColumns} from "./hooks/useOrganShareColumns";
import {useNewWindow} from "../../../hooks/hooks";
import {OrganShareParam} from "../../../types/newWindow";
import {useOrganShareAction} from "./hooks/useOrganShareAction";
import {OrganShareDeallocateDTO} from "../../../types/organShare";
import {useSharedOrganGetter} from "./hooks/useSharedOrganGetter";
import listStyle from "../../../layout/content/list/list.module.scss";

export function OrganShareList() {
    const {
        organShareList,
        totalOrganCount,
        pageCondition,
        searchOrganShareList,
        isChecked
    } = useOrganShareGetter();

    /**
     * 공유 시 소속 정보(organIdx) 사용
     * 공유 취소 시 소속 공유 식별자 사용 (idx (organSharedIdx))
     */
    const [selectedOrganIdx, setSelectedOrganIdx] = useState<number[]>([])
    const [selectedOrganShareIdx, setSelectedOrganShareIdx] = useState<number[]>([])

    const {getSharedOrganList, sharedOrganList} = useSharedOrganGetter();
    const {openOrganManagerAuthorityDetail} = useNewWindow();
    const {filters} = useOrganShareFilters({search: searchOrganShareList({})});
    const {columns} = useOrganShareColumns();
    const {deallocateAuthority} = useOrganShareAction();

    useEffect(() => {
        setSelectedOrganIdx([])
        setSelectedOrganShareIdx([]);

        if (isChecked) {
            resetSharedList()
        }
        //eslint-disable-next-line
    }, [isChecked]);

    // idx 업데이트
    useEffect(() => {
        const sourceList = isChecked ? sharedOrganList.content : organShareList.content;

        const selected = sourceList
            .filter(item => selectedOrganIdx.includes(item.idx))
            .map(item => item.organIdx);

        setSelectedOrganShareIdx(selected);
    }, [selectedOrganIdx, isChecked, sharedOrganList, organShareList]);

    const onClickOrganShare = () => {
        if (selectedOrganIdx.length === 0) {
            alert("공유 할 소속을 선택해주세요.");
            return;
        }

        const param: OrganShareParam = {targetOrganList: selectedOrganShareIdx}
        openOrganManagerAuthorityDetail(param);
    }

    const onClickOrganUnShare = () => {
        if (selectedOrganIdx.length === 0) {
            alert("공유 권한을 제거할 소속을 선택해주세요.");
            return;
        }

        if (window.confirm("선택한 소속을 공유받은 소속 목록에서 제외하시겠습니까?")) {
            const param: OrganShareDeallocateDTO = {organList: selectedOrganIdx};
            deallocateAuthority(param).then(() => resetSharedList())
        }
    }

    const resetSharedList = () => {
        setSelectedOrganIdx([])
        setSelectedOrganShareIdx([]);

        getSharedOrganList({}).then();
    }

    const infoText = isChecked ? "검색한 결과는 공유된(읽기권한) 소속관리자 정보 입니다." : ""

    return (
        <>
            {organShareList && (
                <ListTable
                    filters={filters}
                    buttonsNode={
                        <>
                            <div className={listStyle.infoText}>{infoText}</div>
                            <div>
                                <DetailActionButton onClick={() => onClickOrganUnShare()}>
                                    &nbsp;공유 소속 취소
                                </DetailActionButton>
                                <DetailActionButton onClick={() => onClickOrganShare()}>
                                    <img src={organshareIcon} alt={"소속 공유"}/>
                                    &nbsp;소속 공유
                                </DetailActionButton>
                            </div>
                        </>
                    }
                    listData={isChecked ? sharedOrganList : organShareList}
                    checkedRowIdxArr={selectedOrganIdx}
                    setCheckedRowIdxArr={setSelectedOrganIdx}
                    getList={({page, sort, size}) => searchOrganShareList({page, sort, size})}
                    columns={columns}
                    showCheckbox={() => true}
                    totalRowsCnt={{
                        totalCount: <ListCount totalCount={totalOrganCount ?? 0}
                                               whichList={WhichList.ORGAN}/>,
                        singleUnitKeyInCommonFile: "codeUnit.singleComponent",
                        multipleUnitKeyInCommonFile: "codeUnit.multipleComponent",
                    }}
                    pageOnFilter={pageCondition}
                />
            )}
        </>
    );
}